(function( window, document, $ ){

	'use strict';

	var app = app || {};
		app.load = app.load || {};
		app.config = app.config || {};


	/**
	 *
	 *  App initialize
	 *
	 */
	app.init = function() {

		$.each(app.load, (key, value) => {

	        app.load[key](value);

	    });

	};

	/*
	*shares
	*/
	app.load.share = function() {
		// facebook share
	    $(document).on('click', '.fb-share', function () {
	    	var title = $(this).data('text'),
	    		href  = $(this).data('url'),
	    		img   = $(this).data('img');

	    	$('meta[property=og\\:title]').attr('content', title);
	    	$('meta[property=og\\:url]').attr('content', href);
	    	$('meta[property=og\\:image]').attr('content', img);

    		window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(href), 'facebook-share-dialog', 'width=626,height=436');
	    });

	    // twitter share
		$(document).on('click', '.tw-share', function () {
			var title = $(this).data('text'),
	    		href  = $(this).data('url'),
	    		img   = $(this).data('img');

	    	$('meta[name="twitter:description"]').attr('content', title);
	    	$('meta[name="twitter:title"]').attr('content', title);
	    	$('meta[name="twitter:image"]').attr('content', img);

    		window.open('https://twitter.com/share?original_referer=/&text='+title+'&url='+href, 'Twitter', 'status=no,toolbar=no,scrollbars=yes,titlebar=no,menubar=no,resizable=yes,width=700,height=480,directories=no,location=no');
   			return false;
   		});

   		// google share
		$(document).on('click', '.g-share', function () {
			var href  = $(this).data('url'),
				title = $(this).data('text'),
				img   = $(this).data('img');

			$('meta[property=og\\:title]').attr('content', title);
	    	$('meta[property=og\\:url]').attr('content', href);
	    	$('meta[property=og\\:image]').attr('content', img);

    		window.open('https://plus.google.com/share?url='+href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
   			return false;

   		});
	}

	// Modal popup
	if($('body').hasClass('tpl-homepage') || $('body').hasClass('tpl-program')) {
		if($('body').hasClass('tpl-homepage')) {
			const expirationDuration = 1000 * 60 * 5; // 5 min

			const prevAccepted = localStorage.getItem("accepted");
			const currentTime = new Date().getTime();

			const notAccepted = prevAccepted == undefined;
			const prevAcceptedExpired = prevAccepted != undefined && currentTime - prevAccepted > expirationDuration;
			if (notAccepted || prevAcceptedExpired) {
					$('#myModal').modal('show');
					$('#myModal').modal({
						keyboard: true,
						focus: true,
						show: true,
					});
			  	localStorage.setItem("accepted", currentTime);
			}
		}

		if($('body').hasClass('tpl-program')) {
			const expirationProgramDuration = 1000 * 60 * 5; // 5 min
			let slug = window.location.pathname;

			const prevProgramAccepted = localStorage.getItem("@programAccepted" + slug);
			const currentProgramTime = new Date().getTime();

			const notProgramAccepted = prevProgramAccepted == undefined;
			const prevProgramAcceptedExpired = prevProgramAccepted != undefined && currentProgramTime - prevProgramAccepted > expirationProgramDuration;
			if (notProgramAccepted || prevProgramAcceptedExpired) {
					$('#myModal').modal('show');
					$('#myModal').modal({
						keyboard: true,
						focus: true,
						show: true,
					});
			  	localStorage.setItem("@programAccepted" + slug, currentProgramTime);
			}
		}

	}

	/*
	* Slider
	*/
	app.load.slider = function() {

		if ( $('.owl').length > 0 ) {
			var owl  = $('.owl');

			owl.each(function() {

				var items    = $(this).attr('owl-item'),
					itemsMobile  = $(this).attr('owl-item-mobile'),
					itemsTablet  = $(this).attr('owl-item-tablet'),
					nav      = ( $(this).attr('owl-nav')  == 'true' ),
					navTablet  = ( $(this).attr('owl-nav-tablet')  == 'true' ),
					navMobile  = ( $(this).attr('owl-nav-mobile')  == 'true' ),
					dots     = ( $(this).attr('owl-dots') == 'true' ),
					autoplay = ( $(this).attr('owl-autoplay')  == 'true'),
					center   = ( $(this).attr('owl-center')  == 'true' ),
					autowidth= ( $(this).attr('owl-autoWidth')  == 'true' );
					itemsMobile = parseInt(itemsMobile);
					itemsTablet = parseInt(itemsTablet);
					items = parseInt(items);

				$(this).owlCarousel({
					center: center,
				    margin: 0,
				    dots: dots,
				    loop: true,
				    autoplay: autoplay,
				    autoplayTimeout:7000,
				    animateIn: 'fadeIn',
					animateOut: 'fadeOut',
				    autoplayHoverPause:false,
				    autowidth: autowidth,
				    responsive : {

					    0 : {
					    	items: itemsMobile,
					    	nav: navMobile,
					    	animateIn: false,
					    	animateOut: false
					    },

					    768 : {
							items: itemsTablet,
							nav: navTablet,
					    },

					    1280 : {
							items: items,
							nav: nav,
					    }
					}
				});
			});


		}

		let owlAutoWidth = $('.carousel-autowidth');

		owlAutoWidth.each(function() {
			$(this).owlCarousel({
				margin:110,
			    loop:true,
			    autoWidth:true,
			    items:4,
			    nav:true,			 
			});
		});



	}


	/*
	*  show video
	*/
	app.load.video = function( ) {
		var playing = 0;

		//homepage uploaded video
		$('.play-icon').click(function(e){
		
			if( playing == 0 ) {
				$(this).parent().find('video').attr('controls', true);
				$(this).parent().find('video')[0].play();
				$(this).hide();
				playing = 1;
			}else if( playing == 1 ) {
				$(this).parent().find('video').attr('controls', false);
				$(this).parent().find('video')[0].pause();
				$(this).show();
				playing = 0;
			}
		});

		// homepage youtube video
		$('.embed-play-icon').click(function(e){
			let frame = $(this).parent('.embed-cover').find('iframe');
			console.log(frame)
			var videoURL = frame.prop('src')
			videoURL += "?autoplay=1";
			frame.prop('src',videoURL);
			$(this).parent().find('.embed-poster').hide();
			$(this).hide()

		});



		$('.wp-video').click(function(e){
			if( playing == 0 ) {
				$(this).find('video')[0].play();
				playing = 1;
			}else if( playing == 1 ) {
				$(this).find('video')[0].pause();
				playing = 0;
			}

		});

		if ( $('.wp-video').length ) {

			$('.wp-video').addClass('paused');

			$('.wp-video').find('video')[0].onplay = function() {

				$(this).parents('.wp-video').removeClass('paused');

			}

			$('.wp-video').find('video')[0].onpause = function() {

				$(this).parents('.wp-video').addClass('paused');

			}

		}

	}


    /*
	* filter buttons
	*/
	app.load.filter = function() {
		$('.filter button[data-toggle]').on('click', function(e) {
			var thisbtn = $(this),
				btnID   = thisbtn.data('target');

			thisbtn.addClass('active').siblings().removeClass('active');

			$('.toggle').hide();
			$(btnID).show();

		});

		$('.toggle .close').on('click', function () {
			$(this).parent().hide();
			$(this).parents('.filter').find('button').removeClass('active');
		});

		$(document).mouseup(function (e)
		{
		    var container = new Array();
		    container.push($('#programs'));
		    container.push($('#datepicker'));
		    container.push($('#filter'));

		    $.each(container, function(key, value) {
		        if (!$(value).is(e.target)
		            && $(value).has(e.target).length === 0)
		        {
		            $(value).hide();
		            $('.filter').find('button').removeClass('active');
		        }
		    });
		});

		$(document).keyup(function(e) {

		  if (e.keyCode === 27) {
		  	$('.toggle').hide();
		  	$('.filter').find('button').removeClass('active');
		  }

		});

	}


	/*
	* Masonry
	*/
	app.load.masonryGrid = function() {

		if( $('.masonry-grid').length ) {

			var grid = $('.masonry-grid').masonry({
			  	itemSelector: '.grid-item',
			});

			grid.imagesLoaded().progress( function() {

			  grid.masonry('layout');

			});

		}

	}



	/*
	* sync owl caroulel
	*/
	app.syncOwl = function() {

	    var sync1 = $("#gallery-slide");
		var sync2 = $("#thumbnails");

		var flag = false;
		var counter = 0;

		if ( $('.slide-holder .owl-carousel').length > 0 ) {

			var items        = $('#thumbnails').attr('owl-item'),
				itemsMobile  = $('#thumbnails').attr('owl-item-mobile'),
				itemsTablet  = $('#thumbnails').attr('owl-item-tablet')

			var gallerySlide = $("#gallery-slide").owlCarousel({
				items:1,
				loop:false,
				margin:0,
				autoplay:false,
				autoplayTimeout:6000,
				autoplayHoverPause:false,
				nav: false,
				dots: false,
				lazyLoad:false,
				responsive : {					   
				    0 : {
				    	items: 3,
				    	center: true,
						autoWidth: true,
						margin:8,
				    },
				    768 : {
						items: 1,
						center: false,
						autoWidth: false,
						margin:0,
				    }
				}
			});

			gallerySlide.on('changed.owl.carousel', function(event) {
			    $('.gallery-counter-current').text(event.item.index + 1);
			});
					    
			var thumbs = sync2.owlCarousel({		  
				loop:false,
				margin:8,
				autoplay:false,
				nav: true,
				dots: false,
				responsive : {
				    0 : {
				    	items: 1,				    	
				    },
				    768 : {
						items: itemsTablet,
				    },
				    1280 : {
						items: 3,						
				    },

				    1280 : {
						items: 5,
				    }
				}
			}).on('click', '.owl-item', function(e) {
		        e.preventDefault();
		        sync1.trigger('to.owl.carousel', [$(e.target).parents('.owl-item').index(), 300, true]);

		        $('#thumbnails').find('.owl-item').removeClass('item-active');
		        $(e.target).parents('.owl-item').addClass('item-active');


				var firstChild = $('#thumbnails').find('.owl-item:first-child'),
					lastChild  = $('#thumbnails').find('.owl-item:last-child');

				if(firstChild.hasClass('active')) {
					$('#thumbnails').find('.owl-prev').hide();
				} else if(lastChild.hasClass('active')) {
					$('#thumbnails').find('.owl-next').hide();
				}


			}).on('change.owl.carousel', function(e) {

		        if (e.namespace && e.property.name === 'position' && !flag) {
		    	}

			}).data('owl.carousel');

			$('#thumbnails').find(".owl-item").eq(0).addClass('item-active');
			$('#thumbnails').find('.owl-prev').hide();

			var items       = $('#thumbnails .owl-item').length,
				windowWidth = $(window).width();

			if( items <= 6 && windowWidth > 1280 ) {

				$('#thumbnails').find('.owl-next').hide();

			}else if( items <= 4 && windowWidth > 768 && windowWidth <= 1280 ) {

				$('#thumbnails').find('.owl-next').hide();

			}else if( items <= 3 && windowWidth <= 768 ) {

				$('#thumbnails').find('.owl-next').hide();

			}

			var activeIndex = $("#gallery-slide").find('.active').index();

			$("#gallery-slide").on('change.owl.carousel', function(e) {

				activeIndex = $(this).find('.active').index();
				$('#thumbnails').find('.owl-item').removeClass('item-active');

				if( e.relatedTarget.state.direction == 'left' ) {

					$('#thumbnails').find('.owl-item').eq( activeIndex + 1 ).addClass('item-active');

				} else if( e.relatedTarget.state.direction == 'right' ){

					$('#thumbnails').find('.owl-item').eq( activeIndex - 1 ).addClass('item-active');

				}
			});

			$("#gallery-slide .owl-next").click(function(){
		      	activeIndex = $(this).parents('#gallery-slide').find('.active').index();
				$('#thumbnails').find('.owl-item').removeClass('item-active');

				$('#thumbnails').find('.owl-item').eq( activeIndex ).addClass('item-active');
		    })

		    $("#gallery-slide .owl-prev").click(function(){
		        activeIndex = $(this).parents('#gallery-slide').find('.active').index();
				$('#thumbnails').find('.owl-item').removeClass('item-active');

				$('#thumbnails').find('.owl-item').eq( activeIndex ).addClass('item-active');
		    })

			// show hide arrows
			$('#thumbnails .owl-nav div').click(function(event) {

				var firstChild = $('#thumbnails').find('.owl-item:first-child'),
					lastChild  = $('#thumbnails').find('.owl-item:last-child');

					if(firstChild.hasClass('active')) {
						$('#thumbnails').find('.owl-prev').hide();
					} else if(lastChild.hasClass('active')) {
						$('#thumbnails').find('.owl-next').hide();
					}
			});

		}


		$('img').each(function(){
			var thisImg = $(this);

			thisImg.on('load', function() {
		   		thisImg.parent().css('background-image','none');
		    });

		});


	}


	app.load.syncPostOwl = function(){
		var galleyOwl = $(".owl-sync");
		
		var flag = false;
		var counter = 0;


		galleyOwl.each(function(){
			var sync1 = $(this).find(".owl-gallery-slide");
			var sync2 = $(this).find(".owl-thumbnails");
			var thisGallery = $(this);

			// if ( $('.slide-holder .owl-carousel').length > 0 ) {

				var items        = sync2.attr('owl-item'),
					itemsMobile  = sync2.attr('owl-item-mobile'),
					itemsTablet  = sync2.attr('owl-item-tablet')

				var gallerySlide = sync1.owlCarousel({
					items:1,
					loop:false,
					margin:0,
					autoplay:false,
					autoplayTimeout:6000,
					autoplayHoverPause:false,
					nav: false,
					dots: false,
					lazyLoad:false,
					responsive : {					   
					    0 : {
					    	items: 3,
					    	center: true,
							autoWidth: true,
							margin:8,
					    },
					    768 : {
							items: 1,
							center: false,
							autoWidth: false,
							margin:0,
					    }
					}
				});

				gallerySlide.on('changed.owl.carousel', function(event) {
				    thisGallery.find('.gallery-counter-current').text(event.item.index + 1);
				});
						    
				var thumbs = sync2.owlCarousel({		  
					loop:false,
					margin:8,
					autoplay:false,
					nav: true,
					dots: false,
					responsive : {
					    0 : {
					    	items: 1,				    	
					    },
					    768 : {
							items: itemsTablet,
					    },
					    1280 : {
							items: 3,						
					    },

					    1280 : {
							items: 5,
					    }
					}
				}).on('click', '.owl-item', function(e) {
			        e.preventDefault();
			        sync1.trigger('to.owl.carousel', [$(e.target).parents('.owl-item').index(), 300, true]);

			        sync2.find('.owl-item').removeClass('item-active');
			        $(e.target).parents('.owl-item').addClass('item-active');


					var firstChild = sync2.find('.owl-item:first-child'),
						lastChild  = sync2.find('.owl-item:last-child');

					if(firstChild.hasClass('active')) {
						sync2.find('.owl-prev').hide();
					} else if(lastChild.hasClass('active')) {
						sync2.find('.owl-next').hide();
					}


				}).on('change.owl.carousel', function(e) {

			        if (e.namespace && e.property.name === 'position' && !flag) {
			    	}

				}).data('owl.carousel');

				sync2.find(".owl-item").eq(0).addClass('item-active');
				sync2.find('.owl-prev').hide();

				var items       = $('#thumbnails .owl-item').length,
					windowWidth = $(window).width();

				// if( items <= 6 && windowWidth > 1280 ) {

				// 	sync2.find('.owl-next').hide();

				// }else if( items <= 4 && windowWidth > 768 && windowWidth <= 1280 ) {

				// 	sync2.find('.owl-next').hide();

				// }else if( items <= 3 && windowWidth <= 768 ) {

				// 	sync2.find('.owl-next').hide();

				// }

				var activeIndex = sync1.find('.active').index();

				sync1.on('change.owl.carousel', function(e) {

					activeIndex = $(this).find('.active').index();
					sync2.find('.owl-item').removeClass('item-active');

					if( e.relatedTarget.state.direction == 'left' ) {

						sync2.find('.owl-item').eq( activeIndex + 1 ).addClass('item-active');

					} else if( e.relatedTarget.state.direction == 'right' ){

						sync2.find('.owl-item').eq( activeIndex - 1 ).addClass('item-active');

					}
				});

				sync1.find(".owl-next").click(function(){
			      	activeIndex = $(this).parents('#gallery-slide').find('.active').index();
					sync2.find('.owl-item').removeClass('item-active');

					sync2.find('.owl-item').eq( activeIndex ).addClass('item-active');
			    })

			    sync1.find(".owl-prev").click(function(){
			        activeIndex = $(this).parents('#gallery-slide').find('.active').index();
					sync2.find('.owl-item').removeClass('item-active');

					sync2.find('.owl-item').eq( activeIndex ).addClass('item-active');
			    })

				// show hide arrows
				sync2.find('.owl-nav div').click(function(event) {

					var firstChild = sync2.find('.owl-item:first-child'),
						lastChild  = sync2.find('.owl-item:last-child');

						if(firstChild.hasClass('active')) {
							sync2.find('.owl-prev').hide();
						} else if(lastChild.hasClass('active')) {
							sync2.find('.owl-next').hide();
						}
				});

			// }

		});

		


		// $('img').each(function(){
		// 	var thisImg = $(this);

		// 	thisImg.on('load', function() {
		//    		thisImg.parent().css('background-image','none');
		//     });

		// });

	}


	/*
	* owl caroulel with modal
	*/
	app.load.galleryModal = function() {


	    $('#show-old-gallery').on('shown.bs.modal', function() {

	        APP.syncOwl();

	    });

	    $('.show-gallery-popup').on('shown.bs.modal', function() {

	        APP.syncOwl();

	    });

	    $('.gallery-container a[data-toggle="modal"]').on('click', function(){
	    	var output_gallery_full = $(this).find('.output-gallery-full').html(),
	    		output_gallery_thumbnail = $(this).find('.output_gallery_thumbnail').html();

	    	$('#slide-for-append').empty().append(`<div id="gallery-slide" class="owl-carousel">
		                    							`+ output_gallery_full +`
		                 						   </div>`);

		    $('#thumbnails-for-append').empty().append(`<div id="thumbnails" class="owl-carousel" owl-item="6" owl-item-tablet="4" owl-item-mobile="3">
		                    							`+ output_gallery_thumbnail +`
		                 						   		</div>`);

	    });


	}


	/*
	* show gallery detail
	*/
	app.load.showGallery = function() {

	    if( $('.owl-carousel.sync').length > 0 ) {

	    	APP.syncOwl();
	    }

	}


	/*
	* share animate
	*/
	app.load.shareAnimate = function() {
		var show = false;

		$( ".share-btn" ).click(function() {
			if (!show) {
		        $('.share-pin').animate({right: '0px'}, 300);
		        $('.share-fb').animate({right: '0px'}, 400);
		        $('.share-g').animate({right: '0px'}, 500);
		        $('.share-tw').animate({right: '0px'}, 600);
		        show = true;
		        $(this).html('<i class="fa fa-close" aria-hidden="true"></i>').addClass('bg-opacity');

	        } else if (show) {

	        	$('.share-pin').animate({right: '-45px'}, 600);
		        $('.share-fb').animate({right: '-45px'}, 500);
		        $('.share-g').animate({right: '-45px'}, 400);
		        $('.share-tw').animate({right: '-45px'}, 300);
		        show = false;

		        $(this).html('<i class="fa fa-share-alt" aria-hidden="true"></i>').removeClass('bg-opacity');

	        }
		});
	}


	/*
	* form style
	*/
	app.load.contactForm = function () {
			$('input, textarea').blur(function() {
			  var $this = $(this);
			  if ($this.val())
			    $this.addClass('used');
			  else
			    $this.removeClass('used');
			});

		    $('#email').first().keyup(function () {
			    var email = this.value;

			    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
			    if (!emailReg.test(email)) {

			        $(this).parent().find('.check-valid').removeClass('valid').addClass('not-valid');

			    } else if( email == '') {

			    	$(this).parent().find('.check-valid').removeClass('not-valid valid');

			    }else {

			        $(this).parent().find('.check-valid').removeClass('not-valid').addClass('valid');

			    }

			});

			$('#tel').keyup(function(e) {

				var verified = (e.which == 8 || e.which == undefined || e.which == 0) ? null : String.fromCharCode(e.which).match(/[^0-9]/),
					thisVal = $(this).val();

            	if (verified) {

            		$(this).parent().find('.check-valid').removeClass('valid').addClass('not-valid');

            	} else if( thisVal == '') {

			    	$(this).parent().find('.check-valid').removeClass('not-valid valid');

			    }else {

			        $(this).parent().find('.check-valid').removeClass('not-valid').addClass('valid');

			    }
			});
	}



	/*
	* header menu
	*/
	app.load.headerMenu = function () {

		$('.navbar-toggle[data-target="#navcol-1"]').click(function(){
			// if( $(this).attr('aria-expanded') ) {
				$('body, header').toggleClass('mobile-menu-open');
			// }
		});
		

		$('.primary-nav li a').click(function(e){
			$(this).next('ul').toggle();
		});

	}


	/*
	* search
	*/
	app.load.searchStyle = function () {

		$('.header-search').on('click', function () {
			$('.search-container').addClass('active');
			$('.search').css( "position", 'static');
		});

		$('.close-search').on('click', function () {
			$('.search-container').removeClass('active');
			$('.search').css( "position", 'relative');
		});

		$(document).keyup(function(e) {

		  if (e.keyCode === 27) {
		  	$('.search-container').removeClass('active');
			$('.search').css( "position", 'relative'); 
		  }

		});



		$(document).mouseup(function (e)
		{
		    var container = new Array();
		    container.push($('.search-container'));

		    $.each(container, function(key, value) {
		        if (!$(value).is(e.target)
		            && $(value).has(e.target).length === 0)
		        {
		            $('.search-container').removeClass('active');
		        }
		    });
		});

	}


	/*
	* search end
	*/


	app.load.mainTabs = function () {

		$('.program-filters-url').not('.search-result .program-filters-url, .newsfeed-container .program-filters-url').on('click', function(){

			var url = $(this).attr('data-href');
            window.location.replace(url);

		});

		var activeTerm = $('#filter').attr("active-term");

		$('#filter .program-filters-url').each(function( ) {

			if( $(this).data('cat') == activeTerm ){
				$(this).parent().find('input').attr('checked','checked');
			}
		});

	}


	/*
	* load newsfeed
	*/
	app.load.loadNewsfeed = function () {
		var countGrid = $('.newsfeed-container .grid-item').length,
			klicked = 0;

		if( countGrid < 7 ){
			klicked = 1;
		}


		$('#load-newsfeed').on('click', function() {
			var thisbtn = $(this),
			    url = thisbtn.data('url');

			if( klicked == 0 ) {

				$('.newsfeed-container .grid-item').show();

				var feedMasonry = $('#feed-masonry');
				// feedMasonry.masonry('destroy');

				var grid = $('.masonry-grid').masonry({
					isAnimated: true,
				  	itemSelector: '.grid-item'
				});

				grid.imagesLoaded().progress( function() {

				  grid.masonry();

				});

				klicked = 1;
			} else if( klicked == 1 ) {
				window.location.href = url;
			}

		});
	}


	/*
	* contact form
	*/
	app.load.contact = function () {
		// email validation
		function validateEmail(email) {
		    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		    return re.test(email);
		}


		// contact form
		if ( $('.program-contact-form').length > 0 ) {

			var site_url = $('.program-contact-form').attr('data-url');

			$('.program-contact-form .submit').on('click', function(event) {
				event.preventDefault();
				$('.program-contact-form').submit();
				$(this).addClass('disable-click');
			});

			$('.program-contact-form').submit(function(event) {


				event.preventDefault();

				var name 		= $(this).find('#name'),
					surname 	= $(this).find('#surname'),
					email 		= $(this).find('#email'),
					tel      	= $(this).find('#tel'),
					textarea 	= $(this).find('#text'),
					err 		= 0;


				$(this).find('input,select,textarea').each(function(index, el) {

					if ($(this).val() == ""){
						$(this).addClass('error');
						err = 1 + $($(this)).attr('id');
					}else{
						$(this).closest('.group').removeClass('error');
					}

				});

				// email
				if ( email.val() != "" && validateEmail( email.val() ) ) {
					email.removeClass('error');
				}else{
					email.addClass('error');
					err = 1  + "em2";
				}

				// Remove Validation Errors
				$('.error').on('click', function(event) {
					$(this).removeClass('error');
					$('.program-contact-form .submit').removeClass('disable-click');
				});


				if ( err == 0 ) {

					$.ajax({
						url: site_url + '/wp-admin/admin-ajax.php',
		        		type: 'POST',
		        		data: {
		          			action 		: 'mail_send',
		          			name 		: name.val(),
		          			surname     : surname.val(),
							email 		: email.val(),
							subject 	: "send mail",
							textarea 	: textarea.val(),
							phone       : tel.val(),

		        		},
		        		success : function(data){

			          			var obj = JSON.parse(data);

			          			if(obj.message == "success")
			          			{

			          				$('.submit').after('<p class="success-message">'+translation.emailSendNotification+'</p> ');

		          					$('div.submit').closest('form').find("input, textarea").val("");

			          				$('div.submit').unbind("click");
		        			        setTimeout(function(){
		        			        	$( ".success-message" ).remove();
							        }, 2000);
			          			}
		        		},
		        		error: function(data){
		        			$('div.submit').after('<p class="error-message">'+translation.emailFailed+'</p> ');
        			        setTimeout(function(){
        			        	$( ".error-message" ).remove();
					        }, 2000);
		        		}
					});

				};

			});

		};
	}


	/*
	* search filter
	*/
	app.load.searchFilter = function() {

		if ( $('.search-result').length ) {

			let html = ( data = {} ) => {

				let postType   = data.post_type || '',
					term       = data.term || '',
					image      = data.post_image || '',
					link       = data.post_permalink || '',
					title      = data.post_title || '',
					date       = data.post_modified || '',
					more       = data.more || '',
					cover      = data.gallery_upload_cover || [],
					gallery_count_cover = data.gallery_count_cover || '',
					htmlResult = ``;

				let gallery = '',
					i 		= 1;

				$.each( cover , function(index, val) {

					if ( i < 4 ) {

						gallery += `<div class="gallery-${ i }">
                    		<img src="${ val }" alt="">
                		</div>`;

					}

					i++;

				});

				switch ( postType ) {
				    case "post":
				        htmlResult = `<div class="news-item" data-color = "${term}">
										    <div class="row">
										        <div class="col-md-12">
										            <div class="colorful-bg">

									                    <div class="img-holder pull-left ${ ( image == '' ) ? 'hidden' : '' }">
									                        <a href="${link}">
									                            <img class="img-responsive" src="${image}" />
									                        </a>
									                    </div>

										                <a href="${link}">
										                    <h4 class="list-title"  data-category = "${term}"> ${title}</h4>
										                </a>

										                <span class="date">${date}</span>
										                <p class="description">
										                    ${more}
										                </p>
										            </div>
										        </div>

										    </div>
										</div>`;
				        break;
				    case "team":
				       	htmlResult = `<a href="${link}" class="grid-item">
					                        <div class="">
												<img src="${ ( image ) ? image : '/app/themes/wi-theme/resources/assets/images/user icon-01.png' }" alt="">
					                            <h4>${title}</h4>
					                        </div>
					                    </a>`;
				        break;
				    case 'gallery':
				        htmlResult = `<div class="grid-item">
										${ ( gallery_count_cover == 1 ) ? '<div class="gallery-item-col-one">' : ( (gallery_count_cover == 2) ? '<div class="gallery-item-col-two">' : '<div class="gallery-item-col-three">') }

									        <a href="${link}">

								                ${gallery}

									        </a>
									        <h4 data-category ="${term}">European School English Language Week <small>(${gallery_count_cover} PHOTOS)</small></h4>
									        <h5 class="date">${date}</h5>
									    </div>
									</div>
									`;
				        break;
				    case 'page':
				        htmlResult = `<div class="text-result">
						            	<a href="${link}">
						            		<h4>${title}</h4>
						            	</a>
							            <p>${more}</p>
						            </div>`;
				        break;

				}

				return htmlResult;

			}


			let container = $('.search-result'),
				teamMas = $('#teachers-masonry'),
				gallMas = $('#gallery-masonry'),
			    result    = '';

			let filter = {

				paged : 2,
				postType : '',
				s : container.attr('data-search'),
				catID : 'all',
				getData : function() {
					let paged    = this.paged,
						postType = this.postType,
						s        = this.s,
						catID    = this.catID;

					$.ajax({
						url: '/wp-json/api_search/get',
						type: 'POST',
						dataType: 'json',
						data: {'paged' : paged, 'postType' : postType, 's' : s, 'catID' : catID},
						success: function(data) {


							if( data ) {

								if ( postType == 'team' ) {
									teamMas.masonry('destroy');
								}

								if ( postType == 'gallery' ) {
									gallMas.masonry('destroy');
								}

								if ( postType == 'all' ) {
									var newscont = $('.search-news .search-filtered-content'),
										teamcont = $('#teachers-masonry'),
										gallcont = $('#gallery-masonry'),
										othercont = $('.other-result .search-filtered-content');

									newscont.empty();
									teamcont.empty();
									gallcont.empty();
									othercont.empty();

									$('.search-news').hide();
									$('.search-teachers').hide();
									$('.search-gallery').hide();
									$('.other-result').hide();


									teamMas.masonry('destroy');
									gallMas.masonry('destroy');

									teamcont.append('<div class="grid-sizer"></div>');
									gallcont.append('<div class="grid-sizer"></div>');

									$.each( data.result , function(index, val) {
										let postHtmltab = html( val );

										switch ( val.post_type ) {
					    					case "post":
					    						$('.search-news .search-filtered-content').append(postHtmltab);
					    						$('.search-news').show();
					    						break;
					    					case "team":
										       	teamMas.append(postHtmltab);
										       	$('.search-teachers').show();
										        break;
										    case "gallery":
										    	gallMas.append(postHtmltab);
										    	$('.search-gallery').show();
										        break;
										    case "page":
										        $('.other-result .search-filtered-content').append(postHtmltab);
										        $('.other-result').show();
					    						break;

										};

									});
								}

								$.each( data.result , function(index, val) {

									let postHtml = html( val );

									switch ( postType ) {
				    					case "post":
				    						$('.search-news .search-filtered-content').append(postHtml);

				    						if(!data.count.post) {
				    							$('.search-news .load-more').hide();
				    						}

				    						break;
				    					case "team":

									       	teamMas.append(postHtml);

				    						if(!data.count.team) {
				    							$('.search-teachers .load-more').hide();
				    						}

									        break;
									    case "gallery":

									    	gallMas.append(postHtml);

				    						if(!data.count.gallery) {
				    							$('.search-gallery .load-more').hide();
				    						}
									        break;
									    case "page":
									        $('.other-result .search-filtered-content').append(postHtml);

				    						if(!data.count.page) {
				    							$('.other-result .load-more').hide();
				    						}

									        break;

									};

								});

								if ( postType == 'team') {
									let grid = teamMas.masonry({
									  	itemSelector: '.grid-item',
									  	isAnimated: true,
									  	columnWidth: '.grid-sizer'
									});

									grid.imagesLoaded().progress( function() {
									  	grid.masonry('layout');
									});

								}

								if ( postType == 'gallery') {
									let grid = gallMas.masonry({
									  	itemSelector: '.grid-item',
									  	isAnimated: true,
									  	columnWidth: '.grid-sizer'
									});

									grid.imagesLoaded().progress( function() {
									  	grid.masonry('layout');
									});

								}


							}

			            }
					});

				}

			}



			$('.load-more').click(function(event) {

				event.preventDefault();
				let postType = $(this).attr('data-post-type'),
					paged = $(this).attr('data-paged');
					paged ++;
					$(this).attr('data-paged', paged);

				filter.postType = postType;
				filter.paged = paged;
				filter.getData();

			});


			$('.program-filters-url').click(function(event) {

				$('.program-filters-url').removeClass('active');
				$(this).addClass('active');
				let catID = $(this).data('cat');
				filter.catID = catID;
				filter.paged = 1;
				filter.postType = "all";

				filter.getData();

			});


		}

	}

	/*
	* newsfeed tabs
	*/
	app.load.newsfeedFilter = function() {

		$('.newsfeed-container .program-filters-url ').click(function() {

			$(this).siblings().removeClass('active');
			$(this).addClass('active');

			var catID = $(this).data('cat');
			$('#feed-masonry .grid-item').hide();

			if( $(this).data('cat') == 'all' ){
				$('#feed-masonry .grid-item').show();
			}

			$('#feed-masonry .grid-item').each(function() {
				if( $(this).data('termid') == catID ) {

					$(this).show();

				}
			});


			var feedMasonry = $('#feed-masonry');

			var grid = feedMasonry.masonry({
			  	itemSelector: '.grid-item',
			  	isAnimated: true,
			  	columnWidth: 1

			});

			grid.imagesLoaded().progress( function() {
			  	grid.masonry();
			});

		});
	}



	// click phone button
	app.load.phoneClick = function() {

		$('.phone-icon').toggle(function() {
			let thisbtn = $(this);

		  $('.phone-text').animate({left:'0',width:'160px'});
		  $('.phone').width('auto');
		  thisbtn.parent().addClass('active');


		}, function() {
		  $('.phone-text').animate({left:'64px',width:'0'});
		  $('.phone').animate({width:'64px'});


		});

	}

	app.load.statistic = function() {
		(function($) {
		    $('.statistic-item').find('b').each(function () {
		    	$(this).css({
		    		visibility: 'visible'
		    	});
		    	$('.statistic-item').find('span').css({
		    		visibility: 'visible',
		    	});
		    	if($(this).text().length === 7) {
		    		let first = $(this).text().substring(0, 1);
		    		let second = $(this).text().substring(1,4);
		    		let third = $(this).text().substring(4,7);

					let elem = `
						<span style="font-size: inherit;">${first}</span>
						<em id="millFirstComma">,</em>
						<span style="font-size: inherit;">${second}</span>,
						<span style="font-size: inherit;">${third}</span>
					`;

					$(this).css('display', 'inline-flex');

					$(this).html(elem);

					$(this).find('span').each(function (index) {
						if(index === 0) {
							$(this).hide();
							$('#millFirstComma').hide();

							let that = $(this);

							setTimeout(function() {
								that.prop('Counter',0).animate({
							        Counter: that.text()
							    }, {
							        duration: 2000,
							        easing: 'swing',
							        step: function (now) {
							            that.text(Math.ceil(now));
							        }
							    });

								that.show();
								$('#millFirstComma').show();
							}, 1000);
						} else {
							$(this).prop('Counter',0).animate({
						        Counter: $(this).text()
						    }, {
						        duration: 2000,
						        easing: 'swing',
						        step: function (now) {
						            $(this).text(Math.ceil(now));
						        }
						    });
						}
					});
		    	} else {
				    $(this).prop('Counter',0).animate({
				        Counter: $(this).text()
				    }, {
				        duration: 2000,
				        easing: 'swing',
				        step: function (now) {
				            $(this).text(Math.ceil(now));
				        }
				    });
		    	}
			});


		})(jQuery);
	}



	window.APP = app;
	$(document).ready(app.init);

}) (window, document, jQuery);


// controls
let size_div = $(".custom-links-container .grid-item").size();
let x=9;
let target = $('.load-more');
$('.custom-links-container .grid-item:lt('+x+')').show();
$('.load-more').click(function () {
    x= (x+9 <= size_div) ? x+9 : size_div;
    $('.custom-links-container .grid-item:lt('+x+')').show();
    $('#custom-links-masonry').masonry();
    $('html, body').stop().animate({
        scrollTop: target.offset().top
    }, 1000);
    if( x == size_div ){
    	$(this).hide();
    }
});


jQuery(document).ready(function($) {

	// lightbox
	var lightbox = $('#gallery-slide .item a').simpleLightbox({
		animationSpeed: 200,
		widthRatio: $(window).width() < 767 ? 1 : 0.8,
		heightRatio: 0.8,
		animationSlide: true,
		showCounter: false,
		history: false,
	});

	// footer
	$('.footer-menu-item a.hasChild').click(function(event) {
		event.preventDefault();

		$(this).next('ul').slideToggle();
	});

	$('.footer-menu-title').click(function(event) {
		event.preventDefault();

		if($(window).width() < 1279) {
			$(this).next('ul').slideToggle();
		}
	});

	$(window).resize(function(event) {
		if($(window).width() < 1279) {
			$('.footer-menu-title').next('ul').hide();
		} else {
			$('.footer-menu-title').next('ul').show();
		}
	});

	// side menu
	if($('.side-box').length > 0) {
		if($(window).width() >= 1279) {
			$('#side-affix').stickr({
				offsetTop: 110,
				offsetBottom: -100,
				duration: 300,
			});
		}

		const $sideBox = $('.side-box').clone();
		$('#main-header').after('<div class="header-side-menu"></div>');
	  	$('.header-side-menu').html($sideBox);

		$('.header-side-menu .side-menu-logo.main').on('click', function(event) {
	  		event.preventDefault();

	  		if($(window).width() < 1279) {
	  			$(this).parent('a').next('.side-menu').slideToggle();
	  		}
	  	});

	  	$('.header-side-menu .side-menu-list .has-child > a').on('click', function(event) {
	  		event.preventDefault();

	  		if($(window).width() < 1279) {
	  			$(this).next('ul').slideToggle();
	  		}
	  	});

  		$('.header-side-menu .side-menu-list').each(function(index, el) {
  			$(this).children('li.mobile').last().addClass('last');
  		});
  	}

});

// scroll to top

$("a.scroll-to-top").click(function() {
  $("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
});